// TODO: Import React module
import { useEffect, useState } from 'react';

// TODO: Import MUI module
import { Alert, Box, Button, Grid, Paper, Stack, TextField, Typography } from '@mui/material';

// TODO: Import context
import { fetchData, } from '../../Common/Context';

// TODO: Import custom component
import BoxSubPage from '../../Common/BoxSubPage';

// TODO: Export component
const imageBaseUrl = 'https://www.pohtyh.edu.hk/Files/CafeOrder';
const STORE_KEY = 'TYH_CafeOrder_OrderResults';

const BoxWelcome = ({ setShowWelcome, setShowCatalog }) => {
    // TODO: Define variable
    const [stage, setStage] = useState('entering');

    // TODO: Define event
    useEffect(() => {
        // trigger entering (allows CSS transition)
        const t1 = setTimeout(() => setStage('visible'), 20);

        // after 2s visible start exiting
        const t2 = setTimeout(() => setStage('exiting'), 2020);

        // after exit transition end, hide from parent
        const exitDuration = 500; // ms (matches CSS transition below)
        const t3 = setTimeout(() => {
            setShowWelcome(false);
            setShowCatalog(true);
        }, 2020 + exitDuration);

        return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
    }, [setShowWelcome, setShowCatalog]);

    const styles = {
        container: {
            position: 'fixed',
            inset: 0,
            zIndex: 1400,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.paper',
            // transitions for fade and subtle scale
            transition: 'opacity 500ms ease, transform 500ms ease',
            opacity: stage === 'visible' ? 1 : 0,
            transform: stage === 'entering' ? 'scale(0.98)' : 'scale(1)',
        },
        text: {
            fontWeight: 700,
            textAlign: 'center',
            color: 'text.primary',
            // responsive size
            fontSize: { xs: '3rem', sm: '4rem', md: '6rem' },
            lineHeight: 1,
            userSelect: 'none',
        }
    };

    // TODO: Return component
    return (
        <Box sx={styles.container} role="status" aria-live="polite">
            <Typography component="div" sx={styles.text}>
                Welcome
            </Typography>
        </Box>
    );
};

const BoxCatalog = ({ setShowCatalog, setShowConfirm, setOrder, orderHistory }) => {
    // TODO: Define variable
    const [rows, setRows] = useState([]);

    const latestHistory = Array.isArray(orderHistory)
        ? [...orderHistory].sort((a, b) => {
            const da = a?.createdAt ? new Date(a.createdAt) : new Date(0);
            const db = b?.createdAt ? new Date(b.createdAt) : new Date(0);
            return db - da;
        }).slice(0, 5)
        : [];

    const fmtDate = (iso) => {
        if (!iso) return '';
        try {
            const d = new Date(iso);
            return d.toLocaleString();
        } catch { return iso; }
    };

    // TODO: Define event
    useEffect(() => {
        const formData = new FormData();
        formData.append('action', 'CafeOrder_GetCatalog');
        fetchData(formData, (result) => {
            setRows(result);
        });
    }, []);

    const handleOrderClick = (item) => {
        if (Array.isArray(orderHistory) && orderHistory.length > 0) {
            const latestOrder = orderHistory[orderHistory.length - 1];
            if (latestOrder?.createdAt) {
                const orderTime = new Date(latestOrder.createdAt);
                const currentTime = new Date();
                const timeDiffMs = currentTime - orderTime;
                const timeDiffMinutes = timeDiffMs / (1000 * 60);

                if (timeDiffMinutes < 30) {
                    alert('抱歉!30分鐘內每人只可下單一次!');
                    return;
                }
            }
        }

        setOrder(item);
        setShowCatalog(false);
        setShowConfirm(true);
    };

    const handleClearHistory = () => {
        const confirmed = window.confirm('確定要清除本機的訂單紀錄嗎？This will clear local order history.');
        if (!confirmed) return;
        try {
            localStorage.removeItem(STORE_KEY);
            try {
                window.dispatchEvent(new StorageEvent('storage', { key: STORE_KEY, newValue: null }));
            } catch {
                window.dispatchEvent(new CustomEvent('TYH_CafeOrder_Cleared'));
            }
        } catch (e) {
            console.error('Failed to clear order history', e);
            alert('清除失敗，請查看 console。Clear failed, check console.');
        }
    };

    // TODO: Return component
    return (
        <Stack spacing={2}>
            <Paper sx={{ p: 2 }}>
                <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>訂單紀錄 Order history</Typography>
                    {window.location.href.startsWith('http://localhost') &&
                        <Button size="small" onClick={handleClearHistory} sx={{ mb: 1 }} variant="outlined">清除紀錄 Clear</Button>}
                </Stack>
                {latestHistory.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                        尚無訂單紀錄 No order history yet.
                    </Typography>
                ) : (
                    <Stack spacing={1}>
                        {latestHistory.map((h, idx) => (
                            <Paper key={idx} variant="outlined" sx={{ p: 1 }}>
                                <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
                                    <Box>
                                        <Typography sx={{ fontWeight: 600 }}>{h.itemName ?? '—'}</Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            {`訂單號碼 Order No. ${h.orderNo}`}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ textAlign: 'right' }}>
                                        <Typography variant="caption" color="text.secondary">{fmtDate(h.createdAt)}</Typography>
                                    </Box>
                                </Stack>
                            </Paper>
                        ))}
                    </Stack>
                )}
            </Paper>
            <Grid container spacing={2}>
                {rows.map(item => (
                    <Grid key={item.ID} size={6}>
                        <Stack sx={{ alignItems: 'center' }}>
                            <Box
                                component={'img'}
                                src={`${imageBaseUrl}/${item.ID}.webp`}
                                sx={{ width: 1, maxWidth: 300 }}
                            />
                            <Typography sx={{ fontWeight: 'bold' }} variant="h6">{item.CName}</Typography>
                            <Typography sx={{ fontWeight: 'bold' }} variant="h6">{item.EName}</Typography>
                            <Button
                                onClick={() => handleOrderClick(item)}
                                size="large"
                                sx={{ whiteSpace: 'pre-line' }}
                                variant="contained"
                            >
                                {`下訂單\nPlace an order`}
                            </Button>
                        </Stack>
                    </Grid>
                ))}
            </Grid>
        </Stack>
    );
};

const BoxConfirm = ({ item, setOrder, setOrderNo, setShowCatalog, setShowConfirm, setShowNo, onSaveResult }) => {
    // TODO: Define variable
    const [contact, setContact] = useState('');
    const [email, setEmail] = useState('');
    const [incompleteOrders, setIncompleteOrders] = useState(0);

    // TODO: Define event
    const handleBackClick = () => {
        setShowCatalog(true);
        setShowConfirm(false);
        setOrder({});
    };

    const handleSubmitClick = () => {
        const formData = new FormData();
        formData.append('action', 'CafeOrder_InsertOrder');
        formData.append('itemID', item.ID);
        formData.append('contact', contact);
        formData.append('email', email);

        fetchData(formData, (result) => {
            if (!isNaN(result)) {
                setOrderNo(result);
                setShowConfirm(false);
                setShowNo(true);

                const entry = {
                    orderNo: result,
                    itemID: item?.ID ?? null,
                    itemName: item?.CName ?? item?.EName ?? null,
                    email: email || null,
                    createdAt: new Date().toISOString()
                };
                try {
                    if (typeof onSaveResult === 'function') onSaveResult(entry);
                } catch (e) {
                    console.error('onSaveResult callback failed', e);
                }
            }
        });
    };

    const waitingListAlert = () => {
        if (incompleteOrders > 10) {
            return ({
                CHI: `現時有多個未完成訂單，輪侯時間可能需要30分鐘以上，請耐心等候`,
                ENG: `There are multiple incomplete orders at the moment. The waiting time may take more than 30 minutes. Please be patient.`,
            });
        }
        if (incompleteOrders > 5) {
            return ({
                CHI: `現時有多個未完成訂單，輪侯時間可能需要15分鐘以上，請耐心等候`,
                ENG: `There are multiple incomplete orders at the moment. The waiting time may take more than 15 minutes. Please be patient.`,
            });
        }
        return null;
    };

    useEffect(() => {
        const formData = new FormData();
        formData.append('action', 'CafeOrderStaff_GetIncompleted');
        fetchData(formData, (result) => {
            setIncompleteOrders(parseInt(result));
        });
    }, []);

    // TODO: Return component
    return (
        <Stack spacing={2}>
            <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
                <Box
                    component={'img'}
                    src={`${imageBaseUrl}/${item.ID}.webp`}
                    sx={{ maxWidth: { xs: 168, sm: 256, md: 300 }, width: 1, }}
                />
                <Stack spacing={1}>
                    <Typography sx={{ fontWeight: 'bold' }} variant="h6">{item.CName}</Typography>
                    <Typography sx={{ fontWeight: 'bold' }} variant="h6">{item.EName}</Typography>
                </Stack>
            </Stack>
            <TextField
                label="聯絡號碼 Contact No."
                onChange={(e) => setContact(e.target.value)}
                slotProps={{ inputLabel: { shrink: true } }}
                value={contact}
            />
            <Alert severity="info">
                <Box component="span" sx={{ whiteSpace: 'pre-line' }}>
                    {`聯絡號碼只限是次活動用途，活動完結後資料會被銷毀\nThe contact number is for this event only, and the data will be destroyed after the event ends.`}
                </Box>
            </Alert>
            {/*<TextField
                label="留下電郵地址可收到訂單通知 Leave your email address to receive order notifications"
                onChange={(e) => setEmail(e.target.value)}
                slotProps={{ inputLabel: { shrink: true } }}
                value={email}
            />*/}
            {incompleteOrders > 5 &&
                <Alert severity="warning">
                    <Box component="span" sx={{ whiteSpace: 'pre-line' }}>
                        {`${waitingListAlert().CHI}\n${waitingListAlert().ENG}`}
                    </Box>
                </Alert>}
            <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
                <Button onClick={handleBackClick} size="large" sx={{ flex: 1 }} variant="outlined">
                    {`返回 Back`}
                </Button>
                <Button onClick={handleSubmitClick} size="large" sx={{ flex: 1 }} variant="contained">
                    {`送出訂單 Submit`}
                </Button>
            </Stack>
        </Stack>
    );
};

const BoxNo = ({ no, setShowCatalog, setShowNo }) => {
    // TODO: Define variable

    // TODO: Define event
    const styles = {
        container: {
            position: 'fixed',
            inset: 0,
            zIndex: 1400,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            alignItems: 'center',
            justifyContent: 'center',
        },
        text: {
            fontWeight: 700,
            textAlign: 'center',
            color: 'text.primary',
            // responsive size
            fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
            lineHeight: 1,
            userSelect: 'none',
        }
    };

    // TODO: Define event
    const handleBackClick = () => {
        setShowCatalog(true);
        setShowNo(false);
    }

    // TODO: Return component
    return (
        <Box sx={styles.container}>
            <Typography sx={styles.text}>你的訂單號碼</Typography>
            <Typography sx={styles.text}>Your Order No.</Typography>
            <Typography sx={styles.text}>{no}</Typography>
            <Button onClick={handleBackClick} size="large" variant="contained">返回 Back</Button>
        </Box>
    );
};

const CafeOrder = () => {
    if (window.location.href.startsWith('http://localhost')) console.log('Component CafeOrder Rendered');

    // TODO: Define useContext

    // TODO: Define variable
    const [showWelcome, setShowWelcome] = useState(true);
    const [showCatalog, setShowCatalog] = useState(false);
    const [order, setOrder] = useState({});
    const [showConfirm, setShowConfirm] = useState(false);
    const [showNo, setShowNo] = useState(false);
    const [orderNo, setOrderNo] = useState(null);

    const [orderHistory, setOrderHistory] = useState(() => {
        try {
            const raw = localStorage.getItem(STORE_KEY);
            return raw ? JSON.parse(raw) : [];
        } catch {
            return [];
        }
    });

    // 新增：由父元件統一處理寫入 localStorage 並更新 state，確保立即反映於 BoxCatalog
    const addOrderToHistory = (entry) => {
        setOrderHistory(prev => {
            const next = Array.isArray(prev) ? [...prev, entry] : [entry];
            try {
                console.log(next);
                localStorage.setItem(STORE_KEY, JSON.stringify(next));
            } catch (e) {
                console.error('Failed to write order history to localStorage', e);
            }
            return next;
        });
    };

    // TODO: Define event
    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {
        const handleStorage = (e) => {
            if (e.key === STORE_KEY) {
                try {
                    setOrderHistory(e.newValue ? JSON.parse(e.newValue) : []);
                } catch {
                    setOrderHistory([]);
                }
            }
            // fallback: custom event for environments where StorageEvent couldn't be constructed
            if (e.type === 'TYH_CafeOrder_Cleared') {
                setOrderHistory([]);
            }
        };
        window.addEventListener('storage', handleStorage);
        // listen to custom event fallback too
        const onCleared = () => setOrderHistory([]);
        window.addEventListener('TYH_CafeOrder_Cleared', onCleared);
        return () => {
            window.removeEventListener('storage', handleStorage);
            window.removeEventListener('TYH_CafeOrder_Cleared', onCleared);
        };
    }, []);

    useEffect(() => {
        if (window.location.href.startsWith('http://localhost')) {
            console.log('CafeOrder history:', orderHistory);
        }
    }, [orderHistory]);

    // TODO: Return component
    return (
        <BoxSubPage
            id="CafeOrder"
            disableTop={true}
            disableMenu={true}
            disableSubtitle={true}
            disableDivider={true}
            disableFooter={true}
        >
            <Stack spacing={2} sx={{ mb: 4 }}>
                {showWelcome && <BoxWelcome setShowWelcome={setShowWelcome} setShowCatalog={setShowCatalog} />}
                {showCatalog &&
                    <BoxCatalog
                        setOrder={setOrder}
                        setShowCatalog={setShowCatalog}
                        setShowConfirm={setShowConfirm}
                        orderHistory={orderHistory}
                    />}
                {showConfirm &&
                    <BoxConfirm
                        item={order}
                        setOrder={setOrder}
                        setOrderNo={setOrderNo}
                        setShowCatalog={setShowCatalog}
                        setShowConfirm={setShowConfirm}
                        setShowNo={setShowNo}
                        onSaveResult={addOrderToHistory}
                    />}
                {showNo && <BoxNo no={orderNo} setShowCatalog={setShowCatalog} setShowNo={setShowNo} />}
            </Stack>
        </BoxSubPage>
    );
};

export default CafeOrder;